import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Checkbox, Button, Modal  } from 'antd';
import { api_device } from '../../../api/config';
import { device, initDevice } from '../../../model/config-general';
import { json } from 'stream/consumers';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { isEmpty } from '../../../utils/util';
import { deleteFailureMessage, writeFailureMessage } from '../../../utils/write-result';

const ConfigDevice: React.FC = (prop) => {

    const [data, setData] = useState<any>([]);
    const [device, setDevice] = useState<device[]>([]);

    const init = async () => {
        let getDevice = await api_device('LIST', {});
        if (getDevice.length > 0) {
            setDevice(getDevice);
        } 
    }

    const getConfigModal = (titile: string, content: string) => {
        return {
            title: titile,
            icon: <ExclamationCircleFilled rev={undefined} />,
            content: content,
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            centered: true
        }
    }

    useEffect(() => {
        setDevice(data);
    }, [data]);

    const appendDevice = () => {
        let item = JSON.parse(JSON.stringify(device));
        let object = JSON.parse(JSON.stringify(initDevice));
        if (item.length > 0) {
            let key = item[item.length - 1]['key']
            if (!isEmpty(key)) {
                key = key + 1;
                object.key = key;
            }
        }
        item.push(object);
        setData(item);
    }

    const onDeviceChange = (e: any, index: number) => {
        let key: string = String(e.target.name);
        let value: any = (
            e.target.type === 'checkbox'
                ? (e.target.checked ? 1 : 0)
                : e.target.type === 'radio' ? e.target.value
                : typeof(e.target.value) === 'number' ? Number(e.target.value)
                : String(e.target.value)
        );
        let object: any = device;
        object[index][key] = value;

        setData([...object]);
    }

    const onSaveDevice = async (operation: string, body: any, index: number) => {
        let res = 0;
        let key_id = undefined;

        if (operation == 'DELETE') {
            // `key-id` is the record id, and the Backend deletes by
            // `WHERE id = %s`. This sent `body['name']`, so every delete of
            // a saved device was refused by `validate_key_id` -- which
            // requires a whole number -- before it ever reached the
            // service. `api_device` has no catch either, so the rejected
            // promise showed the operator nothing at all: no success, no
            // error, the row simply stayed.
            key_id = body['id'];
            if (body['id'] == 0) {
                let item = JSON.parse(JSON.stringify(device));
                item.splice(index, 1);
                setData(item);
                res = 1;
            } else {
                try {
                    res = await api_device(operation, body, key_id);
                } catch (err) {
                    // Backend answers a device that is already gone with a
                    // 404 and a sentence written for the user. The generic
                    // "จัดการมูลไม่สำเร็จ" below cannot tell that apart from
                    // a network failure, so a real 4xx says what happened.
                    Modal.error({
                        ...getConfigModal('ผิดพลาด', deleteFailureMessage(err, 'ลบข้อมูลไม่สำเร็จ')),
                    });
                    return;
                }
            }
        } else {
            if (!isEmpty(body['name']) && !isEmpty(body['device'])) {
                // `body['id'] = body['name']` used to sit here. `device.id`
                // is an int column, and Staging's sql_mode is not strict, so
                // MariaDB turned the name into 0 and wrote a row nothing
                // could address -- which is why this screen has never
                // successfully saved anything. The id is now the database's
                // to hand out: a row the operator just added still carries
                // the component's own `id: 0`, which Backend reads as new,
                // and a row that came from LIST carries its real id, which
                // Backend updates in place.
                try {
                    res = await api_device(operation, body, key_id);
                } catch (err) {
                    // Saving can now fail for a reason worth reading: the
                    // device was removed by someone else (404), or the id
                    // was not an id (400). Without this the rejected promise
                    // showed nothing at all.
                    Modal.error({
                        ...getConfigModal('ผิดพลาด', writeFailureMessage(err, 'จัดการมูลไม่สำเร็จ')),
                    });
                    return;
                }
            } else {
                Modal.warning({
                    ...getConfigModal('แจ้งเตือน', 'กรุณากรอกข้อมูลให้ครบถ้วน')
                });
            }
        }

        if (res === 1) {
            Modal.success({
                ...getConfigModal('สำเร็จ', 'จัดการมูลสำเร็จแล้ว'),
                ...{ onOk() { init(); }}
            });
        } else {
            Modal.error({
                ...getConfigModal('ผิดพลาด', 'จัดการมูลไม่สำเร็จ'),
            });
        }
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            <div className='configDeviceContainer'>
                <div className='configBox' style={{marginTop: '20px'}}>
                    <label className='title'>ตั้งค่าอุปกรณ์</label>
                    <Button className='btn-common tool-title' onClick={appendDevice}>+</Button>
                    {
                        device.map((obj, inx) => {
                            return <div className='configDeviceContainerDetail' key={obj.key}>
                                <div className='configDeviceContainerInput'>
                                    <div>
                                        <label>เครื่องที่</label>
                                        <Input value={obj.name} name="name" placeholder="ลำดับอุปกรณ์" onChange={(e: any) => {onDeviceChange(e, inx)}} />
                                    </div>
                                    <div>
                                        <label>IP</label>
                                        <Input value={obj.device} name="device" placeholder="IP" onChange={(e: any) => {onDeviceChange(e, inx)}} />
                                    </div>
                                </div>
                                <div className='configDeviceContainerTool'>
                                    <Button className='btn-common' onClick={() => {onSaveDevice('INSERT', obj, inx)}}><FontAwesomeIcon icon="floppy-disk" /></Button>
                                    <Button className='btn-common' onClick={() => {onSaveDevice('DELETE', obj, inx)}}><FontAwesomeIcon icon="xmark" /></Button> 
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default ConfigDevice;